"use strict";
var Observable_1 = require('../../Observable');
var takeLast_1 = require('../../operator/takeLast');
Observable_1.Observable.prototype.takeLast = takeLast_1.takeLast;
//# sourceMappingURL=takeLast.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/takeLast.js
 ** module id = 597
 ** module chunks = 2
 **/